export default __webpack_public_path__ + "audio/3a69d06ab883c1c3eaf309451e707b01-Health.wav";